export const FETCH_ALL_TEACHER = "FETCH_ALL_TEACHER"
export const GET_ALL_SESSION = "GET_ALL_SESSION"
export const FETCH_ALL_LEARNER = "FETCH_ALL_LEARNER"
export const FILTER_UPCOMING_PAST = "FILTER_UPCOMING_PAST"